module.exports = __webpack_public_path__ + "img/lince_international.6e6e535b.svg";